/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

/* 
,
    
*/

export const TEST_DATA = [
    {
        idx: "21",
        title: "Taste the Sprit of Challengers",
        subtitle: "Taste the Sprit of Challengers",
        serialNo: 'Rare #/21',
        img: "https://i.ibb.co/kym0N1Y/RCB-Players.png",
        tag: 'DIAMOND',
        category: 'diamond',
        price: [
            {
                type: 'fiat',
                currency: 'USD',
                locale: 'en-US',
                amount: 1500.00
            },
            {
                type: 'crypto',
                currency: 'ETH',
                amount: 0.5
            }
        ]
    },
    {
        idx: "22",
        title: "Special edition RCB players jersey inspired IPL pack",
        subtitle: "Taste the Sprit of Challengers",
        serialNo: 'Rare #/22',
        img: "https://i.ibb.co/f9hy2BM/5-Bottles.png",
        tag: 'DIAMOND',
        category: 'diamond',
        price: [
            {
                type: 'fiat',
                currency: 'USD',
                locale: 'en-US',
                amount: 1500.00
            },
            {
                type: 'crypto',
                currency: 'ETH',
                amount: 0.5
            }
        ]
    },
    {
        idx: "23",
        title: "Saini Jersey No Inspired Bottle",
        subtitle: "Saini Jersey No Inspired Bottle",
        serialNo: 'Rare #/23',
        img: "https://i.ibb.co/GnvMTDW/bottle-96.jpg",
        tag: 'DIAMOND',
        category: 'diamond',
        price: [
            {
                type: 'fiat',
                currency: 'USD',
                locale: 'en-US',
                amount: 1500.00
            },
            {
                type: 'crypto',
                currency: 'ETH',
                amount: 0.5
            }
        ]
    },
    {
        idx: "24",
        title: "Chalal Jersey No Inspired Bottle",
        subtitle: "Chalal Jersey No Inspired Bottle",
        serialNo: 'Rare #/24',
        img: "https://i.ibb.co/PC65hk0/5-Bottles-3.jpg",
        tag: 'DIAMOND',
        category: 'diamond',
        price: [
            {
                type: 'fiat',
                currency: 'USD',
                locale: 'en-US',
                amount: 1500.00
            },
            {
                type: 'crypto',
                currency: 'ETH',
                amount: 0.5
            }
        ]
    },
    {
        idx: "25",
        title: "AB Jersey No Inspired Bottle",
        subtitle: "AB Jersey No Inspired Bottle",
        serialNo: 'Rare #/25',
        img: "https://i.ibb.co/qxJ3rbK/5-Bottles-2.jpg",
        tag: 'DIAMOND',
        category: 'diamond',
        price: [
            {
                type: 'fiat',
                currency: 'USD',
                locale: 'en-US',
                amount: 1500.00
            },
            {
                type: 'crypto',
                currency: 'ETH',
                amount: 0.5
            }
        ]
    },
];

export const FilterData = [
    {
        type: "button",
        title: "Type",
        key: "ex4",
        categories: [
            { label: "Crypto", value: "Crypto" },
            { label: "NFT", value: "NFT" },
        ],
    },
    {
        type: "button",
        title: "Country",
        key: "id-4",
        categories: [
            { label: "India", value: "Ind" },
            { label: "U.S.A.", value: "usa" },
            { label: "Canada", value: "canada" },
            { label: "Barbados", value: "barbados" },
            { label: "Dominica", value: "dominica" },
            { label: "Jamaica", value: "jamaica" },
        ],
    },
    {
        type: "checkbox",
        title: "Categories",
        key: "id-5",
        categories: [
            { label: "Badminton", value: "Badminton" },
            { label: "Cricket", value: "Cricket" },
            { label: "Football", value: "Football" },
            { label: "Hockey", value: "Hockey" },
            { label: "Volleyball", value: "Volleyball" },
            { label: "Basketball", value: "Basketball" },
            { label: "Tennis", value: "Tennis" },
            { label: "Table Tennis", value: "Table Tennis" },
            { label: "Baseball", value: "Baseball" },
            { label: "Golf", value: "Golf" },
        ],
    },
    {
        type: "checkbox",
        title: "Time period",
        key: "id-6",
        categories: [
            { label: "2001-2004", value: "2001-2004" },
            { label: "2005-2008", value: "2005-2008" },
            { label: "2009-2012", value: "2009-2012" },
            { label: "2013-2016", value: "2013-2016" },
            { label: "2017-2020", value: "2017-2020", disabled: true },
            { label: "2021", value: "2021" },
        ],
    },
    {
        type: "range",
        title: "Price",
        key: "id-9",
        min: 0,
        max: 200,
        default: "ETH",
        subCategoriesTitle: "Currency",
        categories: [
            { label: "USD", value: "USD" },
            { label: "Ethereum", value: "ETH" },
            { label: "Indian Rupee", value: "INR" },
        ],
    },
];
